export interface SingleFlightHolder<T = void> {
  current: Promise<T> | null;
}

export const runSingleFlight = <T>(
  holder: SingleFlightHolder<T>,
  run: () => Promise<T>,
): Promise<T> => {
  holder.current ??= run().finally(() => {
    holder.current = null;
  });
  return holder.current;
};

export interface EnsureActiveChatParams {
  getActiveChatId: () => string | null;
  setActiveChatId: (chatId: string) => void;
  createChat: () => Promise<{ id: string }>;
  invalidateChatsList: () => void;
}

export const ensureActiveChat = async ({
  getActiveChatId,
  setActiveChatId,
  createChat,
  invalidateChatsList,
}: EnsureActiveChatParams): Promise<boolean> => {
  if (getActiveChatId()) {
    return false;
  }

  const chat = await createChat();
  const hasChatBeenSelectedMeanwhile = !!getActiveChatId();

  if (!hasChatBeenSelectedMeanwhile) {
    setActiveChatId(chat.id);
  }
  invalidateChatsList();
  return !hasChatBeenSelectedMeanwhile;
};
